import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"
import mammoth from 'mammoth'

export default class extends Controller {
  static targets = ["container"]
  static values = { url: String }

  async connect() {
    try {
      const response = await fetch(this.urlValue)
      const arrayBuffer = await response.arrayBuffer()

      const result = await mammoth.convertToHtml({ arrayBuffer })
      this.containerTarget.innerHTML = result.value

      // Log any messages/warnings
      if (result.messages.length > 0) {
        console.log('DOCX conversion messages:', result.messages)
      }
    } catch (error) {
      console.error('Error loading DOCX:', error)
      this.containerTarget.innerHTML = `<p class="text-red-500">${t("javascript.controllers.docx_viewer_controller.error_loading_document")}</p>`
    }
  }
}
